import { OAuthProvider, signInWithPopup } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@shared/services/api/firebase";
import { apiRequest } from "@shared/services/api/apiRequest";
import { AppType } from "@shared/types/app.types";

export async function loginUserWithOAuth(
  appType: AppType,
  provider: OAuthProvider,
  onError?: () => void
) {
  // Determine the API endpoint based on the app type
  let apiEndpoint;

  switch (appType) {
    case "portal":
      apiEndpoint = "/firebase-login/";
      break;
    case "platform":
      apiEndpoint = "/firebase-login/";
      break;
  }

  try {
    // Ensure firebase is initialized
    const auth = await initFirebase();

    // Sign in or register user with OAuth provider
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // Get Firebase token
    const idToken = await user.getIdToken();

    // Prepare API request body
    const body = {
      firebase_token: idToken,
    };

    // Make API call to backend
    const response = await apiRequest(apiEndpoint, "POST", body);

    return { authToken: idToken, ...response };
  } catch (error) {
    clearFirebaseLocalStorage();

    onError?.();

    throw error;
  }
}

export default loginUserWithOAuth;
